<script>
import {logout} from '@/api';
import Config from '@/config';
import Size from "@/mixins/size";
import Main from "@/mixins/main";
import {mapActions, mapGetters} from 'vuex';
import {Image, Button, PullRefresh} from 'vant';

export default {
  mixins: [
    Size,
    Main
  ],
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      refreshing: false
    };
  },
  computed: {
    score() {
      return this.user ? this.user.score : '--';
    },
    isSpecialAccount() {
      return this.user && this.user.source === 50;
    },
    amount() {
      return this.user ? this.user.amount.toFixed(2) : '--.--';
    },
    avatar() {
      return this.user ? this.user.avatar : '/static/images/default-avatar.png';
    },
    showName() {
      return this.user ? this.user.mobile.replace(/^(\d{3})\d{4}(\d{4})/, "$1****$2") : '登录/注册';
    },
  },
  mounted() {
    window.document.title = '速电通-我的';

    this.refreshMyInfo();
  },
  methods: {
    ...mapActions([
      'setUser',
      'setToken'
    ]),
    refresh() {
      this.refreshMyInfo(() => {
        this.refreshing = false;
      });
    },
    toLogin() {
      this.$router.push({name: 'login'});
    },
    toBindCar() {
      this.$router.push({name: 'bindCar'});
    },
    toRecharge() {
      this.$router.push({name: 'recharge'});
    },
    toScoreExchange() {
      this.$router.push({name: 'score'});
    },
    toHelpCharge() {

    },
    toChargeOrder() {
      this.$router.push({name: 'chargeOrder'});
    },
    toBalance() {
      this.$router.push({name: 'balance'});
    },
    toReferrer() {
      this.$router.push({name: 'referrer'});
    },
    toCoupon() {
      this.$router.push({name: 'coupon'});
    },
    logout() {
      logout().then(response => {
        if (response.data.code === Config.successCode) {
          this.setToken('');
          this.setUser(null);
        }
      });
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" :style="{height: (height - 64) + 'px'}" id="userCenter">
    <div class="login">
      <div class="info">
        <div v-if="user" class="name" :class="{'special-account': isSpecialAccount}">{{ showName }}</div>
        <div v-else class="name" @click="toLogin">登录/注册</div>
        <div v-if="user && user.car" class="bind-car">{{ user.car }}</div>
        <div v-else class="bind-car" @click="toBindCar">绑定爱车+</div>
      </div>
      <van-image v-if="user" width="56px" height="56px" round lazy-load :src="avatar"/>
      <div v-else class="sdt-my"></div>
    </div>
    <div class="content">
      <div class="info">
        <div class="left">
          <div class="title">账户余额</div>
          <div class="value">{{ amount }}</div>
          <div class="to-detail" @click="toRecharge">充值</div>
        </div>
        <div class="middle"></div>
        <div class="right">
          <div class="title">我的积分</div>
          <div class="value">{{ score }}</div>
          <div class="to-detail" @click="toScoreExchange">添加</div>
        </div>
      </div>
      <div class="v-split-line"/>
      <div class="menu">
        <div class="item" @click="toChargeOrder">
          <div class="left">
            <div class="icon sdt-order"/>
            <div class="title">我的订单</div>
          </div>
          <div class="sdt-right"/>
        </div>
        <div class="item" @click="toBalance">
          <div class="left">
            <div class="icon sdt-balance"/>
            <div class="title">余额明细</div>
          </div>
          <div class="sdt-right"/>
        </div>
        <div class="item" @click="toScoreExchange">
          <div class="left">
            <div class="icon sdt-score"/>
            <div class="title">我的积分</div>
          </div>
          <div class="sdt-right"/>
        </div>
        <div class="item" @click="toHelpCharge">
          <div class="left">
            <div class="icon sdt-help-charge"/>
            <div class="title">{{ isManager ? '代客充电' : '代我充电' }}</div>
          </div>
          <div class="sdt-right"/>
        </div>
        <div class="item" @click="toReferrer">
          <div class="left">
            <div class="icon sdt-referrer"/>
            <div class="title">我的推荐</div>
          </div>
          <div class="sdt-right"/>
        </div>
        <div class="item" @click="toCoupon">
          <div class="left">
            <div class="icon sdt-coupon"/>
            <div class="title">我的卡券</div>
          </div>
          <div class="sdt-right"/>
        </div>
        <div class="item">
          <div class="left">
            <div class="icon sdt-customer-service"/>
            <div class="title">联系客服</div>
          </div>
          <a class="sdt-telephone" href="tel:02368937176"/>
        </div>
      </div>
      <div class="logout-button-container">
        <div v-if="user" class="logout-button" @click="logout">退出登录</div>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#userCenter {
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  background-color: #009251;
}

#userCenter .login {
  display: flex;
  align-items: center;
  padding: 12px 12px 24px 12px;
  justify-content: space-between;
}

#userCenter .login .info {
  color: white;
  font-size: 22px;
  font-weight: bold;
}

#userCenter .login .info .name.special-account {
  color: #FFC344;
}

#userCenter .login .info .bind-car {
  width: 80px;
  color: white;
  padding: 4px 0;
  font-size: 12px;
  font-weight: 500;
  margin-top: 12px;
  text-align: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
}

#userCenter .login .sdt-my {
  width: 56px;
  height: 56px;
  display: flex;
  color: #ECECEC;
  font-size: 36px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 255, 255, 0.8);
}

#userCenter .content {
  flex: 1;
  background-color: white;
  padding: 24px 24px 0 24px;
  border-radius: 13px 13px 0 0;
}

#userCenter .content .info {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  justify-content: space-between;
}

#userCenter .content .info .left {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
}

#userCenter .content .info .middle {
  width: 0;
  height: 32px;
  border-left: 1px solid #C2C2C2;
}

#userCenter .content .info .right {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
}

#userCenter .content .info .title {
  color: #A2A2A2;
  font-size: 14px;
  font-weight: 500;
}

#userCenter .content .info .value {
  color: #333333;
  margin: 8px 0;
  font-size: 20px;
  font-weight: bold;
}

#userCenter .content .info .to-detail {
  width: 48px;
  color: white;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 8px;
  text-align: center;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  background-color: #009251;
}

#userCenter .content .v-split-line {
  height: 0;
  background-color: white;
  border-top: 1px solid #EEEEEE;
}

#userCenter .content .menu {
  display: flex;
  padding: 12px 0;
  flex-direction: column;
}

#userCenter .content .menu .item {
  display: flex;
  padding: 8px 0;
  align-items: center;
  justify-content: space-between;
}

#userCenter .content .menu .item .left {
  display: flex;
  align-items: center;
}

#userCenter .content .menu .item .left .icon {
  width: 32px;
  height: 32px;
  display: flex;
  color: #009251;
  font-size: 16px;
  font-weight: 500;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background: rgba(0, 146, 81, 0.1);
}

#userCenter .content .menu .item .left .title {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-left: 8px;
}

#userCenter .content .menu .item .sdt-right {
  display: flex;
  color: #333333;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
}

#userCenter .content .menu .item .sdt-telephone {
  color: #333333;
}

#userCenter .logout-button-container {
  flex: 1;
  padding-bottom: 12px;
}

#userCenter .logout-button {
  color: white;
  padding: 12px 0;
  font-size: 14px;
  text-align: center;
  border-radius: 23px;
  background-color: #009251;
  box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
}
</style>
